import { useEffect, useMemo } from "react";
import { useTable } from "react-table";
import primaryComponents from "../../../../primaryComponents";
import styles from "./styles.module.scss";
import secondaryComponents from "../../..";
// import { formatCurrency } from "../../../../../helpers";
// import { useGetInfo } from "../../../../../hooks/useGetInfo";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { formatCurrency } from "../../../../../helpers";
import { useSelector } from "react-redux";

export const useProducts = ({
  billsForm,
  setBillsForm = () => {},
  ...validationParams
}) => {
  const {
    control,
    register,
    trigger,
    setValue,
    formState: { errors },
    // pODetails,
  } = validationParams;
  // const { getStoreInfo } = useGetInfo();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const storeMap = useMemo(() => {
    return (storeList || []).reduce((acc, store) => {
      acc[store.id] = store;
      return acc;
    }, {});
  }, [storeList]);

  useEffect(() => {
    setValue("items", billsForm?.items);
  }, [billsForm?.items]);

  const columns = useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "product_name",
        Cell: ({ cell: { value }, row }) => (
          <span className="d-flex align-items-center">
            <secondaryComponents.ConcatenateWithTooltip
              value={value}
              noOfCharacters={200}
            />
          </span>
        ),
      },
      {
        Header: "Store",
        accessor: "store_id",
        Cell: ({ cell: { value } }) => storeMap[value]?.name || "N/A",
      },
      {
        Header: "Ordered Qty",
        accessor: "requested_quantity",
        Cell: ({ cell: { value } }) => (
          <span
            className={globalStyles["statusBlock"]}
            style={{ minWidth: "auto" }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: "QTY received (Till date)",
        accessor: "total_received",
        Cell: ({ cell: { value } }) => (
          <span
            className={globalStyles["statusBlock"]}
            style={{ minWidth: "auto" }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: "Billed Qty (Till Date)",
        accessor: "total_billed",
        Cell: ({ cell: { value } }) => (
          <span
            className={globalStyles["statusBlock"]}
            style={{ minWidth: "auto" }}
          >
            {value || 0}
          </span>
        ),
      },
      {
        Header: "Bill QTY",
        accessor: "bill_quantity",
        Cell: ({ cell: { value }, row }) => (
          <primaryComponents.InputFieldV2
            control={control}
            name={`items.${row?.index}.bill_quantity`}
            register={register}
            placeholder={"Enter QTY"}
            classNames={`white ${styles.inputField}`}
            value={value}
            step={0.01}
            min={0.01}
            type="number"
            floatError={false}
            errorMessage={errors?.items?.[row?.index]?.bill_quantity}
            onKeyUp={() =>
              errors?.items?.[row?.index]?.bill_quantity &&
              trigger(`items.${row?.index}.bill_quantity`)
            }
            onChange={({ target: { value } }) => {
              const updatedItems = [...instance?.data];
              updatedItems[row.index].bill_quantity = value;

              setBillsForm((prevState) => ({
                ...prevState,
                items: updatedItems,
              }));
            }}
          />
        ),
      },
      {
        Header: "Remaining to Bill",
        Cell: ({ row }) => {
          const quantity_short =
            Number(row?.original?.remaining_billable || 0) +
            (Number(row?.original?.prev_bill_quantity || 0) -
              Number(row?.original?.bill_quantity || 0));

          return (
            <span
              className={`${quantity_short <= 0 ? globalStyles["statusBlock--success"] : globalStyles["statusBlock--failed"]}`}
              style={{ minWidth: "auto" }}
            >
              {quantity_short}
            </span>
          );
        },
      },
      {
        Header: "Cost Price",
        Cell: ({ row }) =>
          formatCurrency({
            value: Number(row?.original?.cost_price),
            currencyCode: storeMap?.[row?.original?.store_id]?.currency_code,
          }),
      },
      {
        Header: "Line Total",
        Cell: ({ row }) =>
          formatCurrency({
            value:
              Number(row?.original?.cost_price) *
              Number(row?.original?.bill_quantity || 0),
            currencyCode: storeMap?.[row?.original?.store_id]?.currency_code,
          }),
      },
    ],
    [errors],
  );

  const instance = useTable({
    columns,
    data: billsForm?.items || [],
  });

  return {
    instance,
  };
};
